import { buildContactoCountryData } from '@shared/utils'

/**
 * This is used to get phone number input
 */
/**
 * Structure: [countryName, isoCode, dialCode, continentCode]
 */
window.contactoCountryData = buildContactoCountryData()
